var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-attend-leave-audit",
    },
    [
      _c(
        "yxt-row",
        {
          staticClass: "yxtbiz-attend-leave-audit__row",
          attrs: { align: "middle", type: "flex" },
        },
        [
          _c(
            "div",
            { staticClass: "color-gray-7 yxtbiz-attend-leave-audit__name" },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_biz_attend_name" /* 考勤名称 */) +
                    _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                )
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "yxtbiz-attend-leave-audit__value color-gray-10" },
            [_vm._v(_vm._s(_vm.attendName))]
          ),
        ]
      ),
      _c(
        "yxt-row",
        {
          staticClass: "yxtbiz-attend-leave-audit__row",
          attrs: { align: "middle", type: "flex" },
        },
        [
          _c(
            "div",
            { staticClass: "color-gray-7 yxtbiz-attend-leave-audit__name" },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_biz_leave_reason" /* 请假原因 */) +
                    _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                )
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "yxtbiz-attend-leave-audit__value color-gray-10" },
            [_vm._v(_vm._s(_vm.leaveReason ? _vm.leaveReason : "--"))]
          ),
        ]
      ),
      _vm.attachments && _vm.attachments.length > 0
        ? _c("yxt-image", {
            staticClass: "yxtbiz-attend-leave-audit__image",
            attrs: {
              src: _vm.attachments[0].url,
              "preview-src-list": [_vm.attachments[0].url],
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }